// Chakra imports
import { Avatar, Box, Flex, Text, useColorModeValue, Button } from "@chakra-ui/react";
import Card from "components/card/Card.js";
import React, { useState, useEffect } from "react";
import WithdrawModal from "./WithdrawModal";
import {useSelector} from 'react-redux';
import { useLocation } from 'react-router-dom';
import UserHead from '@/assets/img/user-head.jpg';
import userStorage from '@/utils/user'
import baseStorage from 'store'

export default function Banner(props) {
  const {balanceVal} = useSelector((store)=>store.balance)
  const { banner, avatar, name, job, posts, followers, following } = props;
  const location = useLocation();
  
  // 使用state来管理mainChart数据，使其能够响应变化
  const [mainChart, setMainChart] = useState(null);
  
  // Chakra Color Mode
  const textColorPrimary = useColorModeValue("secondaryGray.900", "white");
  const textColorSecondary = "gray.400";
  const borderColor = useColorModeValue(
    "white !important",
    "#111C44 !important"
  );
  const userInfo = userStorage.getUserInfo()
  
  // 监听路由变化和组件挂载，实时获取最新的mainChart数据
  useEffect(() => {
    const getLatestMainChart = () => {
      const latestMainChart = baseStorage.get('mainChart');
      setMainChart(latestMainChart);
      console.log('UserCard获取最新mainChart数据:', latestMainChart);
    };
    
    // 初始加载时获取数据
    getLatestMainChart();
    
    // 设置定时器定期检查数据更新（作为补充机制）
    const interval = setInterval(getLatestMainChart, 1000);
    
    return () => clearInterval(interval);
  }, [location.pathname]); // 依赖路由变化
  
  return (
    <Flex mb={{ base: "0px", lg: "0" }} align='center' flexDirection={'column'}> 
      <Box
        bg={`url(${banner})`}
        bgSize='cover'
        borderRadius='16px'
        h='180px'
        w='100%'
      />
      <Avatar
        mx='auto'
        src={userInfo.avatarUrl}
        h='150px'
        w='150px'
        mt='-43px'
        border='4px solid'
        borderColor={borderColor}
      />
      <Text color={textColorPrimary} fontWeight='bold' fontSize='40' mt='10px' mb="10px">
        {mainChart ? mainChart.mchName : '未知'}
      </Text>
      <Text color={textColorPrimary} fontWeight='bold' fontSize='20' mb="20px">
        余额：¥{balanceVal}
      </Text>
      {/* <Text color={textColorSecondary} fontSize='sm'>
        {'暂无作用' || job}
      </Text> */}
      {/* <WithdrawModal /> */}
      <Flex width={'80%'}>
        <Card p='30px 15px'>
          <Flex w='100%' mx='auto' justifyContent={'space-between'}>
            <Flex mx='auto' me='60px' align='center' direction='column' flex={1}>
              <Text color={textColorPrimary} fontSize='2xl' fontWeight='700'>
                {userInfo.realname}
              </Text>
              <Text color={textColorSecondary} fontSize='sm' fontWeight='400' mt="10px">
                联系人
              </Text>
            </Flex>
            <div style={{ width: '1px', height: '100%', backgroundColor: 'rgba(135, 140, 189, 0.3)' }}></div>
            {/* <Flex mx='auto' me='60px' align='center' direction='column'>
              <Text color={textColorPrimary} fontSize='2xl' fontWeight='700'>
                ¥100
              </Text>
              <Text color={textColorSecondary} fontSize='sm' fontWeight='400' mt="10px">
                余额
              </Text>
            </Flex>
            <div style={{ width: '1px', height: '100%', backgroundColor: 'rgba(135, 140, 189, 0.3)' }}></div> */}
            <Flex mx='auto' align='center' direction='column' flex={1}>
              <Text color={textColorPrimary} fontSize='2xl' fontWeight='700'>
                {userInfo.telphone}
              </Text>
              <Text color={textColorSecondary} fontSize='sm' fontWeight='400' mt="10px">
                联系电话
              </Text>
            </Flex>
          </Flex>
        </Card>
      </Flex>

      
    </Flex>
  );
}
